import { render, staticRenderFns } from "./ShippingCompany.vue?vue&type=template&id=330cac08&scoped=true"
import script from "./ShippingCompany.vue?vue&type=script&lang=js"
export * from "./ShippingCompany.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompany.vue?vue&type=style&index=0&id=330cac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330cac08",
  null
  
)

export default component.exports